import React from 'react';

import useNcsaOptIn from './UseNcsaOptIn';

import Views from '../../Views';

import Acknowledgement from '@usas/ui-web/components/acknowledgements/Acknowledgement';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import LoadingModal from '@usas/ui-web/components/dialogs/LoadingModal';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';
import TrueFalseRadioButtonList from '@usas/ui-web/components/radiobuttonlists/TrueFalseRadioButtonList';
import ViewTemplate from '../../components/viewTemplate/ViewTemplate';
import styles from './NcsaOptIn.module.css';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const NcsaOptIn = () => {
  const {
    ncsaOptIn,
    highSchoolGraduationYear,
    showNcsaOptIn,
    imageUrl,
    isLoading,
    ncsaOptInErrorMessage,
    highSchoolGraduationYearErrorMessage,
    showModal,
    signatureErrorMessage,
    signature,
    onBackButtonClicked,
    onNextButtonClicked,
    onItemClick,
    onHighSchoolGraduationYearChanged,
    onModalCanceled,
    onConfirm } = useNcsaOptIn();

  const currentYear = new Date().getFullYear();
  const graduationYearOptions = Array.from({ length: 8 }, (_, i) => {
    const year = currentYear + i;
    return { id: `${year}`, name: `${year}` };
  });

  if ((showNcsaOptIn === false && isLoading !== true) || isLoading === true)
    return (
      <ViewTemplate
        viewName={""}
        onNextButtonClicked={() => { }}>
        <LoadingModal />
      </ViewTemplate>
    )
  return (
    <ViewTemplate
      viewName={Views.NCSA_OPT_IN}
      onBackButtonClicked={onBackButtonClicked}
      onNextButtonClicked={onNextButtonClicked}>
      <div className="row" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
        <div className="col-xs-12 col-md-7 usas-extra-top-margin">
          <img
            src={imageUrl}
            alt="NCSA college recruiting"
            className={`img-responsive ${styles.heroImage}`}
          />
        </div>
        <div className="col-xs-12 col-md-5 usas-extra-top-margin">
          <div className="row" >
            <div className="col-xs-12"><p><b>Does your child want to compete at the college level?</b></p></div>
            <div className="col-xs-12"><p>Find out how NCSA College Recruiting and IMG Academy help high school athletes get recruited to play the sports they love in college. Start with a free recruiting profile visible to every college coach in the country.</p></div>
            <div className="col-xs-12" style={{ color: '#0057b8' }}><p><i>"In my daughters' quest to participate in college athletics, NCSA has given them exposure to colleges and coaches they otherwise would not have had."</i> - Chris Broussard, Fox Sports Analyst & NCSA Parent</p></div>
          </div>
        </div>
      </div>
      <div className="row usas-extra-top-margin" >
        <div className="col-xs-12 col-sm-8 col-md-7">
          <TrueFalseRadioButtonList
            trueLabel="Yes, my child wants to get recruited and compete in college!"
            isVertical={true}
            name="ncsaOptIn"
            value={ncsaOptIn}
            error={ncsaOptInErrorMessage}
            onChange={(value) => { onItemClick(value) }} />
        </div>
        {ncsaOptIn === true &&
          <div className="col-xs-12 col-sm-4 col-md-5">
            <Dropdown
              label={"High School Graduation Year*"}
              name="highSchoolGraduationYear"
              value={highSchoolGraduationYear || ''}
              error={highSchoolGraduationYearErrorMessage}
              message={highSchoolGraduationYearErrorMessage}
              options={graduationYearOptions}
              areValuesIntegers={false}
              setDefaults={false}
              onChange={(value) => { onHighSchoolGraduationYearChanged(value); }} />
          </div>}
      </div>
      <PopUpModal
        widthPct={90}
        maxWidth={720}
        title="NCSA College Recruiting Opt-In Confirmation"
        displayPopUp={showModal === true}
        onModalCanceled={onModalCanceled}>
        <div className="row">
          <div className="col-xs-12">
            <p>By clicking Confirm below, I consent to be contacted by NCSA and its affiliates at the number provided for my account via recurring live or automated calls (including AI/prerecorded) or texts. Consent not required for purchase. I may revoke consent by calling 1-877-845-6272. By clicking Confirm below, I am requesting USA Swimming to share my and/or my child’s personal information with NCSA and its affiliates for purposes of receiving a free NCSA athlete recruiting profile for my child. I agree that this disclosure will include my name, email address and phone number, and the name, email address, graduation year, and gender of my child. I further agree to NCSA’s <a href='https://www.imgacademy.com/privacy-policy?website=ncsasports.org' target="_blank" and rel="noopener noreferrer">Privacy Policy</a> and <a href='https://www.ncsasports.org/terms-and-conditions-of-use' target="_blank" and rel="noopener noreferrer">Terms of Use</a>, including mandatory arbitration.</p>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 usas-extra-top-margin">
            <PrimaryButton type="button" onClick={onConfirm}>Confirm</PrimaryButton>&nbsp;&nbsp;
            <SecondaryButton type="button" onClick={onModalCanceled}>Cancel</SecondaryButton>
          </div>
        </div>
      </PopUpModal>
    </ViewTemplate>
  );
};

export default NcsaOptIn;